<template>
    <q-layout view="hHh lpR fFf">
        <q-header  v-if="logueado">
            <q-toolbar style="min-height:60px">
                <q-btn flat dense round @click="irInicio" style="background:rgba(255,255,255,.12)">
                    <q-icon name="mdi-home" color="white" size="23px" />
                </q-btn>
                <q-toolbar-title>
                    <span style="font-size:16px;font-weight:500;letter-spacing:.01em">
                        AUTOCONTA   
                        </span>
                    </q-toolbar-title>
                <div class="rfc-chip" style="font-size:16px;">{{ $store.state.usuario.rfc }}</div>

                <q-btn flat round dense class="header-btn" @click="drawerEmpresas = !drawerEmpresas">
                    <q-icon name="mdi-domain" color="white" size="23px" />
                    <q-tooltip content-style="font-size:13px">Empresas</q-tooltip>
                </q-btn>

                <q-btn flat round dense class="header-btn" @click="drawerPerfil = !drawerPerfil">
                    <q-icon name="mdi-account" color="white" size="23px" />
                    <q-tooltip content-style="font-size:13px">Perfil</q-tooltip>
                </q-btn>
            </q-toolbar>
        </q-header>

<!-- DRAWER DERECHO -->
<q-drawer :width="320" v-model="drawerPerfil" behavior="mobile" side="right" bordered v-if="logueado"
            style="background:#fff">
            <drawerPerfil />
        </q-drawer>

    <!-- DRAWER EMPRESAS -->
    <q-drawer :width="320" v-model="drawerEmpresas" behavior="mobile" side="right" bordered v-if="logueado"
                style="background:#fff">
                <drawerEmpresas />
            </q-drawer>

        <!-- DRAWER IZQUIERDO -->
        <q-drawer v-model="leftDrawerOpen" show-if-above :mini="miniState" @mouseover="miniState = false"
            @mouseout="miniState = true" :width="250" :breakpoint="500" bordered content-class="bg-purple-1">
            <q-scroll-area class="fit" :horizontal-thumb-style="{ opacity: 0 }">
                <q-list padding>
                    <q-item active clickable v-ripple @click="irDescargas">
                        <q-item-section avatar>
                            <q-icon name="mdi-download" />
                        </q-item-section>
                        <q-item-section>
                            Descargas
                        </q-item-section>
                    </q-item>
                    <q-separator />
                    <q-item active clickable v-ripple @click="irDescargasXMLS">
                        <q-item-section avatar>
                            <q-icon name="mdi-file-xml-box" />
                        </q-item-section>
                        <q-item-section>
                            Descarga XML'S
                        </q-item-section>
                    </q-item>
                    <q-separator />
                    <q-item active clickable v-ripple @click="irDescargasMetadata">
                        <q-item-section avatar>
                            <q-icon name="mdi-package-down" />
                        </q-item-section>
                        <q-item-section>
                            Descarga Metadata
                        </q-item-section>
                    </q-item>
                    <q-separator />
                </q-list>
            </q-scroll-area>
        </q-drawer>

        <q-page-container>
            <router-view />
        </q-page-container>

        <q-footer style="height: 30px;" bordered class="bg-dark text-white">
            <q-toolbar>
                <q-toolbar-title>
                </q-toolbar-title>
            </q-toolbar>
        </q-footer>
    </q-layout>
</template>

<script>
import { ref } from 'vue'
import axios from "axios";
import drawerPerfil from "../DrawerPerfil/DrawerPerfil.vue"
import drawerEmpresas from '../DrawerEmpresas/DrawerEmpresas.vue'

export default {
    name: 'MainLayout',
    components: {
        drawerPerfil, drawerEmpresas
    },
    data() {
        return {
            drawerPerfil: false,
            isDarkMode: false,
            leftDrawerOpen: false,
            drawer: false,
            miniState: true,
            drawerEmpresas: false,

        }
    },
    computed: {
        logueado() {
            return this.$store.state.usuario;
        },
        token() { return this.$store.state.empresaStore },

    },
    watch: {
        isDarkMode(val) {
            // Cambia entre modo oscuro y claro
            this.$q.dark.set(val);
        }
    },
    methods: {
        irInicio() {
            this.$router.push({ name: 'Home' })
        },
        irDescargas() {
            this.$router.push({ name: 'Descargas' })
        },
        irDescargasXMLS() {
            this.$router.push({ name: 'DescargasXMLS' })
            this.$store.state.listaHistorialDescargasCFDIStore = []

        },
        irDescargasUUID() {
            this.$router.push({ name: 'DescargasUUID' })
            this.$store.state.listaHistorialDescargasUUIDStore = []

        },
        irDescargasMetadata() {
            this.$router.push({ name: 'DescargasMetadata' })
            this.$store.state.listaHistorialDescargasMetadataStore = []
        },
    }
}
</script>
